













































































































































































































































































































































































import Vue from 'vue'
import dayjs from 'dayjs'
import { ValidationObserver } from 'vee-validate'
import Icon from '@/components/globals/Icon.vue'
import ProfileSelectWithValidation from '@/components/modal/ProfileModal/ProfileSelectWithValidation.vue'
import ProfileBirthdayInputsWithValidation from '@/components/modal/ProfileModal/ProfileBirthdayInputsWithValidation.vue'
import ProfileSexWithValidation from '@/components/modal/ProfileModal/ProfileSexWithValidation.vue'
import { StoreAuthUser } from '@/store/modules/auth/types'
import InputWithValidation from '@/components/globals/basics/InputWithValidation.vue'
import SnackbarComponent from '@/components/globals/basics/Snackbar.vue'
import snackbar from '@/tools/snackbar'
import {
  updateProfile,
  UrgentRelationship,
  urgentRelationshipsOptions,
  profileUrgentRelationshipLabels,
  profileGenderLabels,
  Gender,
} from '@/core/Profiles'
import { getAuthUser } from '@/core/Auth'
import { getAddressFromPostalCode } from '@/core/PostalCodes'

// @ts-ignore
export default Vue.extend({
  components: {
    Icon,
    ValidationObserver,
    InputWithValidation,
    ProfileSelectWithValidation,
    ProfileBirthdayInputsWithValidation,
    ProfileSexWithValidation,
    SnackbarComponent,
  },
  filters: {
    formatDate(date: string): string {
      return dayjs(date).format('YYYY / MM / DD')
    },
  },
  data() {
    return {
      loading: false,
      profile: {
        lastName: '',
        lastNameKana: '',
        firstName: '',
        firstNameKana: '',
        sex: 'women' as Gender,
        birthday: '',
        tel: '',
        urgentTel: '',
        urgentRelationship: '' as UrgentRelationship,
        postalCode: '',
        prefecture: '東京都',
        address1: '',
        address2: '',
      },
      urgentRelationshipOther: '',
      isShowUrgentTelPopOver: false,
      isConfirming: false,
      isSubmitted: false,
    }
  },
  computed: {
    urgentRelationshipsOptions() {
      return urgentRelationshipsOptions
    },
    selectedGender(): string {
      const gender = this.profile.sex
      return profileGenderLabels[gender]
    },
    selectedRelationship(): string {
      const relationship = this.profile.urgentRelationship
      return profileUrgentRelationshipLabels[relationship]
    },
    isSelectedRelationshipOther(): boolean {
      // TODO: 緊急連絡先の属性をenumにする
      return this.profile.urgentRelationship === 'その他'
    },
  },
  watch: {
    'profile.lastName': {
      handler(newVal) {
        this.profile.lastName = newVal.replace(/ /g, '　')
      },
    },
    'profile.firstName': {
      handler(newVal) {
        this.profile.firstName = newVal.replace(/ /g, '　')
      },
    },
    'profile.tel': {
      handler(newVal) {
        this.profile.tel = newVal.replace(/-/g, '')
      },
    },
    'profile.urgentTel': {
      handler(newVal) {
        this.profile.urgentTel = newVal.replace(/-/g, '')
      },
    },
  },
  methods: {
    close() {
      this.$modal.pop()
      if (this.$route.query.intended) {
        this.$router.push(String(this.$route.query.intended))
      }
    },
    async validate(): Promise<boolean> {
      const observer = this.$refs.form as InstanceType<
        typeof ValidationObserver
      >
      const result: boolean = await observer.ctx.validate()
      if (result === false) {
        this.scrollIntoFirstError()
      }
      return result
    },
    scrollIntoFirstError(): void {
      const observer = this.$refs.form as InstanceType<
        typeof ValidationObserver
      >
      const errors: Record<string, string[]> = observer.ctx.errors
      for (let k of Object.keys(errors)) {
        if (errors[k].length > 0) {
          //@ts-ignore
          this.$refs[k].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
          break
        }
      }
    },
    async updateProfile() {
      if (this.isSubmitted || !(await this.validate())) {
        this.isConfirming = false
        return
      }

      this.isSubmitted = true
      try {
        await updateProfile(this.$store.getters['auth/user'].id, {
          ...this.profile,
          urgentRelationship: (this.profile.urgentRelationship === 'その他'
            ? this.urgentRelationshipOther
            : this.profile.urgentRelationship) as UrgentRelationship,
        })

        //TODO: api呼び出さずにフォームの内容から取得する
        const authUser = await getAuthUser()
        this.$store.commit(new StoreAuthUser(authUser))
        snackbar({
          text: `プロフィールのご登録ありがとうございます。GYYMにてプログラムをお楽しみください。 `,
        })
        this.close()
        this.$emit('completed')

        this.isConfirming = false
      } catch (error) {
        this.isConfirming = false
        // @ts-ignore
        this.$refs.form.setErrors(error.errors)
        this.scrollIntoFirstError()
      }
      this.isSubmitted = false
    },
    handlePostalCodeInput() {
      if (this.loading || this.profile.postalCode.length !== 7) return
      this.fetchPref()
    },
    onConfirm() {
      this.isConfirming = true
    },
    onConfirmCancel() {
      this.isConfirming = false
    },
    async fetchPref() {
      try {
        const address = await getAddressFromPostalCode(this.profile.postalCode)
        this.profile.prefecture = address.prefecture
        this.profile.address1 = address.address1 + address.address2
        // @ts-ignore
        // this.$refs.address2.$refs.input.focus();// 入れたかったけどfetchとうまいことやれなかった
      } catch (_) {
        // 不正な郵便番号が入力された場合にエラーになる
        // 頻度が高いのでスルーさせる
      }
    },
  },
})
